/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { GrowthHistoryCreateDto } from '../../models/growth-history-create-dto';
import { GrowthHistoryDto } from '../../models/growth-history-dto';

export interface GrowthHistoryControllerCreate$Params {
      body: GrowthHistoryCreateDto
}

export function growthHistoryControllerCreate(http: HttpClient, rootUrl: string, params: GrowthHistoryControllerCreate$Params, context?: HttpContext): Observable<StrictHttpResponse<GrowthHistoryDto>> {
  const rb = new RequestBuilder(rootUrl, growthHistoryControllerCreate.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<GrowthHistoryDto>;
    })
  );
}

growthHistoryControllerCreate.PATH = '/api/growth-history';
